<template>
  <snt-select
    class="barcode-select"
    :items="items"
    placeholder="โปรดเลือก"
    name="barcode-type"
    outlined
    dense
    hide-details
    @input="onChange($event)" />
</template>

<script>
import { GET_BARCODE_FORMAT_ENUM } from '@/resources/graphql'

export default {
  methods: {
    onChange (value) {
      this.$emit('input', value)
    }
  },
  apollo: {
    items: {
      fetchPolicy: 'network-only',
      query: GET_BARCODE_FORMAT_ENUM,
      update: ({ __type: { enumValues } }) => enumValues.map(({ name: value, description: text }) => ({
        text,
        value
      }))
    }
  }
}
</script>

<style lang="scss" scoped>
.barcode-select {
  max-width: 415px;
}
</style>
